import React from 'react';
export var InfoCircleFilledIcon = function InfoCircleFilledIcon(_a) {
  var className = _a.className;
  return React.createElement("svg", {
    className: className,
    width: "16",
    height: "16",
    viewBox: "0 0 48 48"
  }, React.createElement("g", null, React.createElement("path", {
    d: "M24,1C36.694,1 47,11.306 47,24C47,36.694 36.694,47 24,47C11.306,47 1,36.694 1,24C1,11.306 11.306,1 24,1ZM26,18L22,18L22,38L26,38L26,18ZM26,10L22,10L22,14L26,14L26,10Z"
  })));
};